module.exports = "https://99designs-start-assets.imgix.net/js/4f9c56b23571aee0714ce393707e1fe0.svg";